
export function getIconMarkup(name) {
  return (
    `<span class="icon" aria-hidden="true">
      <svg class="icon__svg icon__${name}-dims">
        <use xlink:href="/static/icons-20260608.svg?v=2#${name}"></use>
      </svg>
    </span>`
  );
}
